
















import {Component, Prop, Vue, ProductRecommendation, ComponentStyle, ComponentStyleDefinition} from "@zoovu/runner-browser-api";

@Component({})
export default class ProductComparisonSelectorView extends Vue {

    @Prop()
    recommendation: ProductRecommendation;

    @ComponentStyle()
    componentStyle: ComponentStyleDefinition;

    onSelectClicked() {
        this.recommendation.toggleSelection();
    }

    sendCompareEvent() {
        this.$root.$emit("start-compare");
    }
}
